function isSentryEnabled(): boolean {
  return import.meta.env.VITE_SENTRY === "true";
}

export { isSentryEnabled };
